import { combineReducers } from '@reduxjs/toolkit';

import task from './task';
import user from './user';
import theme from './theme';
import settings from './settings';
import userSettings from './userSettings';
import toolSettings from './toolSettings';
import taskSettings from './DccJsonToTabs/taskSettings';
import comment from './comment';
import aceConnect from './aceConnect';
import dynamicCheckItemConfig from './DccJsonToTabs/dynamicCheckItemConfig';
import version from './version';
import addVersion from './addVersion';
import taskQueue from './taskQueue';
import assets from './assets';
import uploadingTaskQueue from './uploadingTaskQueue';
import artist from './artist';
import messageBox from './messageBox';

const rootReducer = combineReducers({
  task,
  user,
  theme,
  settings,
  userSettings,
  taskSettings,
  toolSettings,
  comment,
  addVersion,
  aceConnect,
  dynamicCheckItemConfig,
  version,
  assets,
  taskQueue,
  uploadingTaskQueue,
  artist,
  messageBox,
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
